import { Button, Tooltip } from "@mui/material";
import { useHasPermissionState } from "../../../api/iam";

// Single API-backed action. Disabled with a loading hint while its permission
// check is in flight, then either rendered (permitted) or hidden (denied) so
// it never appears clickable before we actually know the user is allowed.
const ActionButton = ({
  action,
  method = "PATCH",
  path,
  text,
  variant = "outlined",
  sx,
  onClick,
  startIcon,
}) => {
  const { hasPermission, isLoading } = useHasPermissionState(
    path,
    method,
    action
  );

  if (!isLoading && !hasPermission) {
    return null;
  }

  const button = (
    <Button
      size="small"
      variant={variant}
      startIcon={startIcon}
      sx={sx}
      disabled={isLoading}
      onClick={onClick}
    >
      {text}
    </Button>
  );

  return isLoading ? (
    <Tooltip title="Checking permissions…">
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default ActionButton;
